export default __webpack_public_path__ + "static/SFMono-SemiboldItalic-4373d817004bd5dc253e0dba90839565.ttf";